import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getMenuItemsForRole } from '../../config/role-routes';

// Definir los items del menú


interface DashboardLayoutProps {
  children: React.ReactNode;
  title?: string;
}

export function DashboardLayout({ children, title }: DashboardLayoutProps) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const isActiveRoute = (path: string) => {
    if (path === '/admin') {
      return location.pathname === '/admin';
    }
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const getRoleLabel = (role: string) => {
    const roles: Record<string, string> = {
      sys_admin: 'Administrador del Sistema',
      general_manager: 'Gerente General',
      project_lead: 'Líder de Proyecto',
      accountant: 'Contador',
      contractor: 'Contratista',
      receptionist: 'Recepcionista',
      data_entry: 'Capturista de Datos',
      client: 'Cliente'
    };
    return roles[role] || role;
  };

  const getInitials = (name: string) => {
    return name.charAt(0).toUpperCase();
  };

  // Filtrar items del menú según el rol del usuario
  const userRole = user?.role || '';
  const visibleMenuItems = getMenuItemsForRole(userRole);

  return (
    <div className="dashboard-layout">
      {/* Sidebar */}
      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <img 
            src="/img/logo.png" 
            alt="Gran Arquitectura" 
            className="sidebar-logo"
          />
        </div>

        <div className="sidebar-user">
          <div className="user-avatar">
            {user?.name ? getInitials(user.name) : '👤'}
          </div>
          <div className="user-info">
            <span className="user-name">{user?.name || 'Usuario'}</span>
            <span className="user-role">{user ? getRoleLabel(user.role) : 'Cargando...'}</span>
          </div>
        </div>

        <nav className="sidebar-nav">
          <ul>
            {visibleMenuItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={isActiveRoute(item.path) ? 'active' : ''}
                  onClick={closeSidebar}
                >
                  <span className="nav-icon">{item.icon}</span>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <button onClick={logout} className="logout-btn">
          🚪 Cerrar Sesión
        </button>
      </aside>

      {/* Main Content */}
      <main className="main-content">
        <header className="top-header">
          <div className="header-left">
            <button className="menu-toggle" onClick={toggleSidebar}>
              ☰
            </button>
            <h1>{title || 'Dashboard'}</h1>
          </div>
          <div className="header-right">
            <div className="header-user">
              {user?.name || 'Usuario'}
              <span className="header-role">{user ? getRoleLabel(user.role) : ''}</span>
            </div>
          </div>
        </header>

        <div className="content-area">
          {children}
        </div>
      </main>
    </div>
  );
}